var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('expose',{staticClass:"tournaments-expose",attrs:{"active":_vm.$root.tournamentsVisible === true},on:{"expose-close":function($event){_vm.$root.tournamentsVisible = null}}},[(_vm.$root.tournamentsVisible === true)?_c('tournaments-demo',{ref:"gameWindow",staticClass:"tournaments-expose__window"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-024e6264","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/TournamentsExpose.vue
// module id = null
// module chunks = 